import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { apiGetDetail, apiEditInfo } from '../../request/api'
import { Modal, message } from 'antd';
import { useCustomData } from '../../pages/context/mineCustomDataProvider';

interface CheckPayOrderProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
}
interface PageData {
    orderStatus: string;
    payType: string;
    orderPrice: string;
    chooseCommodity: string;
    created_at: string;
    payAt: string;
    createdAt: string;
    id: string;
    informeUser: string;
    createdTime: string;
    launchCompany: string;
}

const CheckPayOrder: React.FC<CheckPayOrderProps> = ({ handleViewChange, data }) => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const [selectedPayItem, setSelectedPayItem] = useState<string | null>(null);
    const [messageApi, contextHolder] = message.useMessage();
    const languageCode = localStorage.getItem('siteLanguage') || 'zh';
    const [commodityInfo, setCommodityInfo] = useState<any>(null);
    const [companyName, setCompanyName] = useState<string>('');
    const [pageInfo, setPageInfo] = useState<PageData>({
        orderStatus: '',
        payType: '',
        orderPrice: '',
        chooseCommodity: '',
        created_at: '',
        payAt: '',
        createdAt: '',
        informeUser: '',
        createdTime: '',
        launchCompany: '',
        id: '',
    });
    const { getValue } = useCustomData();
    const serviceInfo = getValue('serviceInfo');
    const serviceName = getValue('serviceName');
    const price = getValue('price');
    const orderNumber = getValue('orderNumber');
    const orderCreated = getValue('orderCreated');
    const payTypeText = getValue('payType');
    const orderInfo = getValue('orderInfo');
    const back = getValue('back');
    const account = getValue('account');
    const bank = getValue('bank');
    const payComfirm = getValue('payComfirm');
    const companyName1 = getValue('companyName');
    const remittance = getValue('remittance');

    useEffect(() => {
        apiGetDetail({
            tid: 'F32F1F7909694585A88B730331221DB3',
            languagecode: languageCode,
            id: data
        }).then(res => {
            const orderData = res.data.data;
            setPageInfo(orderData);

            // 拉取商品详情
            apiGetDetail({
                tid: '72D99CCB9A7E439184BF9EF7CABC49BA',
                languagecode: languageCode,
                id: orderData.chooseCommodity
            }).then(res2 => {
                setCommodityInfo(res2.data.data);
            });

            // 拉取公司详情
            if (orderData.launchCompany) {
                apiGetDetail({
                    tid: 'E85B2C2CBF4C45FC89D7D540D35F780F',
                    languagecode: languageCode,
                    id: orderData.launchCompany
                }).then(res3 => {
                    setCompanyName(res3.data?.data?.componyName || '');
                });
            }
        }).catch(console.error);
    }, []);

    const goback = () => {
        handleViewChange('ordercenter')
    }

    const goPay = () => {
        if (selectedPayItem === null) {
            messageApi.open({
                type: 'error',
                content: '请选择支付方式',
            });
            return;
        }

        const now = new Date();
        const pad = (n: number) => n.toString().padStart(2, '0');
        const payAt = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;

        const payload = {
            tid: 'F32F1F7909694585A88B730331221DB3',
            id: data,
            payType: selectedPayItem,
            chooseCommodity: pageInfo.chooseCommodity,
            orderStatus: '汇款确认',
            orderPrice: pageInfo.orderPrice,
            informeUser: pageInfo.informeUser,
            payAt: payAt,
            launchCompany: pageInfo.launchCompany,
            createdTime: pageInfo.createdTime
        };

        apiEditInfo(payload).then(() => {
            messageApi.success('已经收到您的支付请求');
            setTimeout(() => {
                handleViewChange('ordercenter');
            }, 2000);
        }).catch(() => {
            messageApi.error('支付失败，请重试');
        });
    };

    const handlePayItemClick = (payType: string) => {
        setSelectedPayItem(payType);
    };

    return (
        <div className="CheckPayOrder">
            {contextHolder}
            <div className='detail-back' style={{ color: themeColor }} onClick={goback}>
                <ArrowLeftOutlined />
                <div className='detail-back-right'> {back} </div>
            </div>
            <p className='mine-h3'>{serviceInfo}</p>
            <div className='check-order'>
                <div className='check-item'>
                    <p>{serviceName}</p>
                    <p className='check-item-p'>{commodityInfo?.commodityName || '-'}</p>
                </div>
                <div className='check-item'>
                    <p>{price}</p>
                    <p className='check-item-p'>{commodityInfo?.menberPrice || '-'}</p>
                </div>
            </div>
            <p className='mine-h3'>{orderInfo}</p>
            <div className='check-order'>
                <div className='check-item'>
                    <p>{orderNumber}</p> 
                    <p className='check-item-p'>{pageInfo.id}</p>
                </div>
                <div className='check-item'>
                    <p>{orderCreated}</p>
                    <p className='check-item-p'>{pageInfo.createdTime}</p>
                </div>
                <div className='check-item'>
                    <p>{companyName1}</p>
                    <p className='check-item-p'>{companyName || '-'}</p>
                </div>
            </div>
            <p className='mine-h3'>{payTypeText}</p>
            <div className='pay-order'>
                <div
                    className={`pay-item ${selectedPayItem === '汇款' ? 'selected' : ''}`}
                    onClick={() => handlePayItemClick('汇款')}
                    style={{
                        borderColor: selectedPayItem === '汇款' ? themeColor : '#e5e5ee',
                        color: selectedPayItem === '汇款' ? themeColor : '#33364b'
                    }}
                >
                    <p className='pay-header'>{remittance}</p>
                    <p>{account}:xxxxxxxxxxx</p>
                    <p>{bank}:xxxxxxxxxxx</p>
                </div>
                <div
                    className={`pay-item ${selectedPayItem === 'PayPal' ? 'selected' : ''}`}
                    onClick={() => handlePayItemClick('PayPal')}
                    style={{
                        borderColor: selectedPayItem === 'PayPal' ? themeColor : '#e5e5ee',
                        color: selectedPayItem === 'PayPal' ? themeColor : '#33364b'
                    }}
                >
                    <p className='payPal'>PayPal</p>
                </div>
            </div>
            <button className='pay-button' style={{ background: themeColor, boxShadow: "0 2px 4px 0 " + themeColor }} onClick={goPay}>{payComfirm}</button>
        </div>
    );
};

export default CheckPayOrder;